import { parseCarouselResponse } from './carousel-data-parser';

/**
 * Fetch all slides for a carousel.
 * @param {string} endpoint to fetch carousel slide data
 */
export async function fetchCarouselSlides(endpoint) {
  const response = await fetch(endpoint);
  if (!response.ok) {
    throw Error(response.statusText);
  }

  const json = await response.json();

  return parseCarouselResponse(json);
}
